// filepath: c:\Users\phili\Documents\Kioskapp\my-app\src\index.js
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import App from './App';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('root');
  if (!container) {
    console.error('Could not find root element to mount React app');
    return;
  }
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  );
  // 🛟 Signal an den Boot-Wächter in index.html: die App ist gestartet.
  // Bleibt das aus (z. B. halb hochgeladener Bundle während eines Deploys →
  // Parse-Fehler), lädt index.html nach 15 s automatisch neu.
  window.__appBooted = true;
});

// filepath: c:\Users\phili\Documents\Kioskapp\my-app\public\index.html
<div id="root"></div>